interface Global {
  versionInfo: string;
}

function getGlobals(): Global {
  const uiParameterContainer: HTMLElement | null = document.getElementById("uiParameter");

  let versionInfo = uiParameterContainer?.dataset?.versionInfo;
  if (!versionInfo || versionInfo === "%versionInfo%") {
    versionInfo = "Version 0.0.1";
  }

  return {
    versionInfo
  };
}

export const globals: Global = getGlobals();
